import { EmptyListPlaceholder } from '@frontend/components/elements/EmptyListPlaceholder';
import { getSelectedLanguage } from '@frontend/translate';

export function NoFinancingSearchResults(props: { isInitialLoad: boolean; numberOfItems: number }) {
    const language = getSelectedLanguage();
    const { isInitialLoad, numberOfItems } = props;

    if (isInitialLoad) {
        return (
            <EmptyListPlaceholder
                doNotWrapInCard={true}
                subtitle={language.finance.performFinancingSearch}
            />
        );
    }

    if (!numberOfItems) {
        return (
            <EmptyListPlaceholder
                doNotWrapInCard={true}
                subtitle={language.common.noSearchResults}
            />
        );
    }
}
